<template>
<div class="login">

	<div v-if="loginBrand" class="login-logo-wrapper">
		<img v-if="loginBrand == 'Flight Deck'" src="@/assets/img/flightdecklogosimple.svg" class="login-logo">
		<img v-if="loginBrand == 'Flight Deck Lite'" src="@/assets/img/flightdecklitelogosimple.svg" class="login-logo">
		<img v-if="loginBrand == 'FFL Office'" src="@/assets/img/fflofficelogosimple.svg" class="login-logo">
	</div>
	<div v-else class="empty-list">Loading...</div>

	<div class="content">

		<h1>Forgot Password</h1>

		<label>Username:</label>
		<input type="text" v-model="username" ref="username">

		<template v-if="showForgotPasswordControls">
			<div class="note">Enter your username and we will send you a new temporary password with instructions for logging in again.<br><br></div>
			<div></div>
			<button class="button action" @click.stop.prevent="doPasswordReset()">Send Temporary Password</button>
			<div v-if="!loading" class="forgot">
				<router-link class="link" to="/login">Cancel forgot password and return to login...</router-link>
			</div>
			<div class="message" >{{ message }}</div>
		</template>

		<template v-if="showTemporaryPasswordControls">
			<label>Temporary Password:</label>
			<input type="password" v-model="temporaryPassword" ref="temporaryPassword" @keyup.enter="validateTemporaryPassword()">
			<div></div>
			<div class="note">Check your email for your new temporary password and enter it above.</div>
			<div></div>
			<button class="button action" @click.stop.prevent="validateTemporaryPassword()">Validate Temporary Password</button>
			<div></div>
			<div class="message" >{{ message }}</div>
		</template>

		<template v-if="showResetPassword">
			<label class="label">Enter a New Password:</label>
			<input type="password" v-model="password">
            <label class="label">Retype New Password:</label>
			<input type="password" v-model="retype_password">
			<div></div>
			<button class="button forgot action" @click="doSetNewPassword()">Reset Password</button>
			<div></div>
			<div class="message" >{{ message }}</div>
		</template>

		<template v-if="resetPasswordSuccess">
			<label>Password:</label>
			<input type="password" v-model="password" ref="password">
			<div></div>
			<div class="note">Your password has been reset!<br>Sign In to proceed.</div>
			<div></div>
			<button class="button action" @click="doLogin()">Sign In</button>
			<div></div>
			<div class="message" >{{ message }}</div>
		</template>

    	<loading v-if="loading"></loading>

	</div>

</div>
</template>

<script>
export default {
	name: 'login',
	data() {
		return {
			loading: true,
			loginBrand: '',
			username: '',
			temporaryPassword: '',
    		password: '',
    		retype_password: '',
			temporaryPasswordSent: false,
			showForgotPasswordControls: true,
			showTemporaryPasswordControls: false,
    		showResetPassword: false,
    		resetPasswordSuccess: false,
    		message: '',
		}
	},
	// watch: {
	// 	'$store.state.client': function() {
	// 		this.setLoginBrand()
	// 	}
	// },
	created() {
	},
	mounted() {
		if (this.$route.query.username) {
			this.username = this.$route.query.username
			this.$refs.password.focus();
		} else {
			this.$refs.username.focus();
		}
		this.returnTo = (this.$route.query.return) ? decodeURI(this.$route.query.return) : ''
		if (this.$route.query.logout) {
			this.doLogout()
		}
		if (this.$route.query.code == 'expired') {
			this.sessionExpired = true
		}
		this.setLoginBrand()
	},
	methods: {
    	doPasswordReset() {
	    	if (!this.username) return
		    this.message = ''
			this.loading = true
    		this.apiCall({ destination: 'forgot_password', data: { user_name: this.username, login_url: document.location.protocol + '//' + document.location.hostname }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.showForgotPasswordControls = false
					this.showTemporaryPasswordControls = true
    			} else {
					this.message = obj.message
				}
    		})
	    },
		validateTemporaryPassword() {
			if (this.loading) { return }
		    this.message = ''
			this.loading = true
    		this.apiCall({ destination: 'validate_temporary_password', data: { user_name: this.username, password: this.temporaryPassword }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.showForgotPasswordControls = false
					this.showTemporaryPasswordControls = false
					this.showResetPassword = true
    			} else {
					this.message = obj.message
				}
    		})
		},
	    doSetNewPassword() {
			if (this.loading) { return }
		    this.message = ''
    		if (!this.retype_password || !this.password) return
    		if (this.retype_password != this.password) {
	    		this.message = 'Passwords do not match'
	    		return
	    	}
			this.loading = true
    		this.apiCall({ destination: 'reset_password', data: { user_name: this.username, password: this.password }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					this.showResetPassword = false
					this.resetPasswordSuccess = true
    			} else {
	    			this.message = obj.message
    			}
    		})
		},
		doLogin() {
			if (this.loading) { return }
		    this.message = ''
			this.loading = true
    		this.apiCall({ destination: 'login', data: { user_name: this.username, password: this.password }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					// now that user is logged in, call get_client
					this.apiCall({ destination: 'get_client' }).then(obj => {
						this.fetchFlightDeckMenus()
						this.fetchShoppingCartCount()
						let loginResult = JSON.parse(JSON.stringify(obj))
						if (loginResult.force_password_change) {
							this.$router.push('/reset-password')
						} else if (loginResult.user.user_type_code == 'ADMIN') {
							this.$router.push('/admin')
						} else if (this.$route.query.return) {
							this.$router.push(decodeURI(this.$route.query.return))
						} else if (loginResult.redirect) {
							this.$router.push('/' + loginResult.redirect)
						} else if (loginResult.reload) {
							// reload vs redirect -- legacy needs to reload
							document.location =  '//' + document.location.host + loginResult.reload
						} else if (loginResult.return) {
							this.$router.push('/' + loginResult.return)
						} else {
							this.$router.push(this.getUserHome)
						}
					})
    			} else {
	    			this.message = obj.message
    			}
    		}).catch(err => {
				console.log(err);
			})
		},
		backToLogin() {
			this.$router.push('/login')
		},
		setLoginBrand() {
			switch(this.getClientTypeCode) {
				case 'FLIGHT_DECK_LITE':
					this.loginBrand = 'Flight Deck Lite'
					break;
				case 'FFL_OFFICE':
					this.loginBrand = 'FFL Office'
					break;
				case 'ADMIN':
					this.loginBrand = 'Admin'
					break;
				case 'CDS':
				default:
					this.loginBrand = 'Flight Deck'
					break;
			}
			this.loading = false
		}
	}
}
</script>
